import React, { useCallback, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getPermissions } from "../reducers/permissionsReducer";
import { Layout, Menu } from 'antd';
import arthaLogo from '../assets/images/Artha-Finance Logo.svg';
import arthaLogoWhite from '../assets/images/Artha-Finance Logo-Light.svg';
import Loader from './shared/loader.component';
import Profile from './header/profile';
import Switcher from './Switcher';

const AppHeader = (props) => {
  const navigate = useNavigate();
  const { Sider } = Layout;
  const [isShowSider] = useState(false);
  const [collapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState(['1']);
  const [selectedKeys, setSelectedKeys] = useState();
  const [menuItems, setMenuItems] = useState([]);
  const { SubMenu } = Menu;

  const filteredFeatures = useSelector((state) => state.commonData?.cardspermissionsconfig) || [];

  useEffect(() => {
    if (props.userProfile?.role === "Customer") {
      window.open(process.env.REACT_APP_USER_URL, '_self');
      return;
    }
    if (!filteredFeatures || filteredFeatures.length === 0) return; // 👈 wait until features are available
    const _currentPath = window.location.pathname;
    // Always update menu items once loaded
    setMenuItems(filteredFeatures);
    // Determine which menu item is active
    const currentPath = (_currentPath === '/callback' || _currentPath === '/' || _currentPath.includes('/dashboard'))
      ? filteredFeatures?.[0]?.path
      : _currentPath;

    const activeMenuItem = findActiveMenuItem(filteredFeatures, currentPath);

    if (activeMenuItem) {
      setSelectedKeys([activeMenuItem.key]);
      setOpenKeys([activeMenuItem.parentKey || activeMenuItem.key]);
      // Navigate if on root/callback
      if (_currentPath === '/' || _currentPath === '/callback') {
        navigate(activeMenuItem.path); // 👈 force navigation after deciding default
      }
    }
  }, [filteredFeatures?.length, props.userProfile?.id, window.location.pathname]);

  const findActiveMenuItem = (items, path) => {
    if (!Array.isArray(items)) return null;
    for (let item of items) {
      if (item.path === path) return item;
      if (Array.isArray(item.Features) && item.Features.length > 0) {
        const child = item.Features.find(child => child.path === path);
        if (child) return { ...child, parentKey: item.key };
      }
    }
    return null;
  };
  const handleClick = useCallback((path, key, parentKey) => () => {
    if (path) {
      setSelectedKeys([key]);
      if (!parentKey) {
        setOpenKeys([]);
      } else {
        setOpenKeys([parentKey]);
      }
      navigate(path);
    }
  }, [navigate]);
  const onOpenChange = useCallback((keys) => {
    setOpenKeys(keys);
  }, [])
  return (
    <>
      <div className="lg:hidden w-full bg-bodyBg max-lg:fixed right-0 border-b border-sidebarBr py-2 px-3 flex items-center gap-3 justify-end">
        <Switcher className="block md:hidden" />
        <Profile />
      </div>
      <div className='overflow-auto max-lg:bg-bodyBg z-[9999] relative px-0 mb-4 md:h-auto h-screen border-r border-sidebarBr md:border-0'>
        <div className="custom-header" id="area">

          <div className='logo-section flex items-center justify-center mt-12 mx-auto lg:mt-5 lg:mb-6 cursor-pointer'>
            <img className='logo dark:hidden w-[100px]' src={arthaLogo} alt='Artha' />
            <img className='logo hidden dark:block w-[100px]' src={arthaLogoWhite} alt='Artha' />
          </div>
          <Menu mode="inline" selectedKeys={selectedKeys} openKeys={openKeys} className='sider-menu-list bg-sidebarBg mt-8' onOpenChange={onOpenChange}>
            {menuItems && menuItems.length >= 0 ? (
              menuItems.map((item) => (
                item.Features && item.Features.length > 0 ? (
                  <SubMenu key={item.key} title={<div className='text-menutextColor'><span className={`icon ${item.Name}`}></span><span className='text-sm font-medium text-menutextColor inline-block'> {item.Name}</span></div>}>
                    {item.Features.map((child) => (
                      <Menu.Item key={child.key} onClick={handleClick(child.path, child.key, item.key)} style={{ paddingLeft: 42 }}>
                        <span className={`icon ${child.Name}`}></span><span className='text-sm font-medium text-menutextColor inline-block'>{child.Name}</span>
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item key={item.key} onClick={handleClick(item.path, item.key)} style={{ paddingLeft: 12 }}>
                    <span className={`icon ${item.Name}`}></span><span className='text-sm font-medium text-menutextColor inline-block'>{item.Name}</span>
                  </Menu.Item>
                )
              ))
            ) : (
              <Loader />
            )}
          </Menu>
        </div>
      </div>
      {isShowSider && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          collapsedWidth={0}
          className={`${collapsed ? '' : "sideropen"}`}
        >
          <div className="mobile-head" id="area">
            <Menu
              mode="inline"
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
            >
              {menuItems?.map((item) => (
                item.Features && item.childs.length >= 0 ? (
                  <SubMenu key={item.key} title={<span><span className={`icon ${item.Name}`}></span> <span className='text-sm font-medium text-menutextColor inline-block'>{item.Name}</span></span>}>
                    {item.Features?.map((child) => (
                      <Menu.Item key={child.key} onClick={handleClick(child.path, child.key)}>
                        <span className='text-sm font-medium text-menutextColor inline-block'>{child.Name}</span>
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item key={item.key} onClick={handleClick(item.path, item.key)}>
                    <span className={`icon ${item.Name}`}></span><span className='text-sm font-medium text-menutextColor inline-block'>{item.Name}</span>
                  </Menu.Item>
                )
              ))}
            </Menu>
          </div>
        </Sider>
      )}
    </>
  );
};
const connectStateToProps = ({ auth, AdminData, permissions, oidc }) => {
  return {
    auth: auth,
    adminType: AdminData?.AdminType,
    permissions,
    userProfile: oidc.user,
    menu: AdminData?.cardspermissionsconfig,
    highlightedmenuItem: AdminData?.highlightedmenuItem
  };
};
export default connect(connectStateToProps, (dispatch) => {
  return {
    fetchMenuItemPermissions: (pKey, userId) => {
      dispatch(getPermissions({ customerId: userId, perKey: pKey }));
    }, dispatch
  };
})(AppHeader);
AppHeader.propTypes = {
  auth: PropTypes.string,
  adminType: PropTypes.string,
  userProfile: PropTypes.object,
};
